<template>
  <svg aria-hidden="true" fill="currentColor" viewBox="0 0 1000 1000" ...attributes>
    <path
      d="M841.3 981.6l140.3-140.3a62.2 62.2 0 0 0 0-88.2L728.6 500l253-253a62.2 62.2 0 0 0 0-88.3L841.3 18.4a62.2 62.2 0 0 0-88.2 0L500 271.4l-253-253a62.2 62.2 0 0 0-88.3 0L18.4 158.7a62.2 62.2 0 0 0 0 88.2l253 253.1-253 253a62.2 62.2 0 0 0 0 88.3l140.3 140.3a62.2 62.2 0 0 0 88.2 0l253.1-253 253 253a62.7 62.7 0 0 0 88.3 0z"
    ></path>
  </svg>
</template>
